import classNames from 'classnames'

import type { ReactElement, ReactNode } from 'react'

import './styles.scss'

interface Props {
  children: ReactNode
  className?: string
  variant?: 'default' | 'success' | 'warning' | 'error'
}

const Banner = ({ children, className, variant = 'default' }: Props): ReactElement => {
  return <div className={classNames('banner-component', className, variant)}>{children}</div>
}

export default Banner
